// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-b1dd9f1e] .el-card__body{padding:15px}.czmj[data-v-b1dd9f1e]{color:#999;font-size:12px}.czmjNum[data-v-b1dd9f1e]{font-size:20px;margin-top:5px;padding-bottom:8px;border-bottom:1px solid #dcdfe6!important}.no-bor[data-v-b1dd9f1e]{border-bottom:0 solid #dcdfe6!important}.czl[data-v-b1dd9f1e]{font-size:12px;margin-top:10px}.ftzClor[data-v-b1dd9f1e]{color:#999}.down[data-v-b1dd9f1e]{color:#67c23a}.top[data-v-b1dd9f1e]{color:#f56c6c}", ""]);
// Exports
module.exports = exports;
